import Link from 'next/link'

const WebPortfolioItem = ({
   href,
   title,
   description,
   industry,
   country,
   builtFor,
   technologies,
   IconComponent,
   reverse = false,
}) => {
   return (
      <Link className="portfolio-bg-img" href={href} passHref>
         <div
            className={`row cs-bg-primary rounded-5 p-4 gx-5 w-100 ${
               reverse ? 'mt-4 flex-row-reverse' : ''
            }`}
         >
            <div
               className={`col-3 d-none d-lg-block cs-bg-theme-color-2 portfolio-svg-round web-portfolio-svg-shadow`}
            >
               <IconComponent />
            </div>
            <div className="col web-portfolio-content cs-text-secondary">
               <h2 className="web-portfolio-content-title">{title}</h2>
               <p className="web-portfolio-content-description">
                  {description}
               </p>
               <div
                  className="web-portfolio-other-data   d-flex mb-3"
                  style={{ gap: '60px' }}
               >
                  <div className="">
                     <div className="web-portfolio-small-text">INDUSTRY</div>
                     <div className="web-portfolio-medium-text">{industry}</div>
                  </div>
                  <div className="">
                     <div className="web-portfolio-small-text">COUNTRY</div>
                     <div className="web-portfolio-medium-text">{country}</div>
                  </div>
                  <div className="">
                     <div className="web-portfolio-small-text">BUILT FOR:</div>
                     <div className="web-portfolio-medium-text">{builtFor}</div>
                  </div>
               </div>
               <div className="web-portfolio-technologies">
                  <div className="web-portfolio-small-text">TECHNOLOGY:</div>
                  <div className="web-portfolio-medium-text">
                     {technologies}
                  </div>
               </div>
            </div>
         </div>
      </Link>
   )
}

export default WebPortfolioItem
